export default "__VITE_ASSET__CLU8KWyU__"